<!-- If reference Id is generated -->
<div *ngIf="referenceId" class="flex flex-col justify-center items-center md:gap-5 gap-3">
    <img src="assets/icons/info-check.svg" alt="Icon" class="h-20 w-20 mb-4" />

    <h2 class="text-(--text-primary) leading-10 lg:text-[32px] text-2xl font-semibold sm:text-start text-center">
        {{ 'BUSINESS_ONBOARDING.CREATED_TITLE' | translate }}
    </h2>

    <p class="text-(--text-muted) font-medium text-base leading-6 md:mt-8 mt-4">
        {{ 'BUSINESS_ONBOARDING.REFERENCE_ID' | translate }}
    </p>

    <h4 class="flex gap-5 text-(--text-primary) text-2xl font-semibold items-center">
        #{{ referenceId }}
        <img src="assets/icons/copy.svg" alt="Copy Icon" class="cursor-pointer hover:opacity-80 transition w-6 h-6"
            (click)="copyReferenceId(referenceId)" />
    </h4>

    <p class="info-note">
        {{ 'BUSINESS_ONBOARDING.REFERENCE_NOTE' | translate }}
    </p>

    <div class="w-full md:mt-20 mt-8">
        <p class="mb-5 text-generic">
            {{ 'BUSINESS_ONBOARDING.MAKE_SURE_READY' | translate }}
        </p>

        <div class="flex flex-wrap gap-6 sm:justify-between justify-center">
            <div class="app-container bg-[#FDD9011A]">
                <div class="app-icon">
                    <img src="assets/icons/registration.svg" alt="icon" class="w-6 h-6" />
                </div>
                <p class="text-[#AA9600] app-text">
                    {{ 'BUSINESS_ONBOARDING.REGISTRATION' | translate }}
                </p>
            </div>

            <div class="app-container bg-[#8AB3FF1A]">
                <div class="app-icon">
                    <img src="assets/icons/address-proof.svg" alt="icon" class="w-6 h-6" />
                </div>
                <p class="text-[#003FB5] app-text">
                    {{ 'BUSINESS_ONBOARDING.ADDRESS_PROOF' | translate }}
                </p>
            </div>

            <div class="app-container bg-[#3E43451A]">
                <div class="app-icon">
                    <img src="assets/icons/id.svg" alt="icon" class="w-6 h-6" />
                </div>
                <p class="text-[#1C1E1F] app-text">
                    {{ 'BUSINESS_ONBOARDING.NATIONAL_ID' | translate }}
                </p>
            </div>
        </div>

        <app-button text="{{ 'BUSINESS_ONBOARDING.CONTINUE_APPLICATION' | translate }}" type="button" variant="primary"
            size="lg" extraClass="sm:mt-15 mt-8 w-full mb-10" (action)="moveOnToCompanyDetailsStep()"></app-button>
    </div>
</div>

<!-- If reference Id is not generated -->
<div *ngIf="!referenceId" class="pb-8">
    <p class="mb-8 text-generic">
        {{ 'BUSINESS_ONBOARDING.ENTER_INFO' | translate }}
    </p>

    <form [formGroup]="applicantDetailsForm" class="space-y-4 flex flex-col" (ngSubmit)="handleFormSubmission()">
        <app-input-field label="{{ 'BUSINESS_ONBOARDING.ROLE' | translate }}"
            placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" [control]="getControl('role')"></app-input-field>

        <app-input-field label="{{ 'BUSINESS_ONBOARDING.NAME' | translate }}"
            placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" [control]="getControl('name')"></app-input-field>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
            <app-input-field label="{{ 'BUSINESS_ONBOARDING.EMAIL' | translate }}" type="email"
                placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}"
                 [control]="getControl('email')"></app-input-field>

            <app-input-field label="{{ 'BUSINESS_ONBOARDING.MOBILE' | translate }}" type="number" [isMobile]="true"
                placeholder="7900000000" [control]="getControl('mobile')"></app-input-field>
        </div>

        <app-button text="{{ 'LOGIN.CONTINUE' | translate }}" type="submit" variant="primary" size="lg"
            extraClass="mt-3" [disabled]="applicantDetailsForm.invalid"></app-button>
    </form>
</div>